<mat-sidenav-container>
  <mat-sidenav #sidenav>
  </mat-sidenav>
  <mat-sidenav-content style="text-align: center">
    <mat-nav-list>
      <a mat-list-item routerLink='/revenue/location' routerLinkActive='list-item-active'>
        <mat-icon aria-hidden="false">room</mat-icon>&nbsp; Locations</a>
    </mat-nav-list>
    <mat-divider></mat-divider>
    <mat-nav-list>
      <a mat-list-item routerLink='/revenue/journal-entry' routerLinkActive='list-item-active'>
        <mat-icon aria-hidden="false">list</mat-icon>&nbsp; Journal Entries</a>
    </mat-nav-list>
    <mat-divider></mat-divider>
    <mat-nav-list>
      <a mat-list-item routerLink='/revenue/provider' routerLinkActive='list-item-active'>
        <mat-icon aria-hidden="false">device_hub</mat-icon>&nbsp; Providers</a>
    </mat-nav-list>
    <mat-divider></mat-divider>
<!--    <mat-nav-list>-->
<!--      <a mat-list-item routerLink='/revenue/tools' routerLinkActive='list-item-active'>-->
<!--        <mat-icon aria-hidden="false">build</mat-icon>&nbsp; Tools</a>-->
<!--    </mat-nav-list>-->
<!--    <mat-divider></mat-divider>-->
    <mat-nav-list>
      <a mat-list-item routerLink='/revenue/monitoring' routerLinkActive='list-item-active'>
        <mat-icon aria-hidden="false">assessment</mat-icon>&nbsp; Jobs</a>
    </mat-nav-list>
    <mat-divider></mat-divider>
    <mat-nav-list>
      <a mat-list-item routerLink='/revenue/settings' routerLinkActive='list-item-active'>
        <mat-icon aria-hidden="false">settings</mat-icon>&nbsp; App Settings</a>
    </mat-nav-list>
    <mat-divider></mat-divider>
    <br/>
  </mat-sidenav-content>
</mat-sidenav-container>
